import React, {Component, Fragment} from 'react'
import Select from 'react-select'


import utility from '../utility';
import Utility from '../utility';
import ReactTooltip from "react-tooltip";
import Sidebar from "./sidebar";

let initialState = {
    height: 0,
    length: 0,
    pieces: 0,
    selectedEq: "Aufkantung",
    drawValues: {
        ausenecke: {
            a: 50,
            b: 20,
            c: 120,
            angle: 45
        },
        innenecke: {
            a: 50,
            b: 20,
            c: 120,
            angle: 45
        }
    }
};

class Equipments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedEq: "Aufkantung",
            height: 0,
            length: 0,
            pieces: 1,
            url: this.props.equipments[0].url,
            drawValues: {
                ausenecke: {
                    a: 50,
                    b: 20,
                    c: 120,
                    angle: 45
                },
                innenecke: {
                    a: 50,
                    b: 20,
                    c: 120,
                    angle: 45
                }
            },
        }
        initialState.url = this.props.equipments[0].url
        this.keypress = this.keypress.bind(this);
        this.selectEquipment = this.selectEquipment.bind(this);
        this.renderEquipments = this.renderEquipments.bind(this);
        this.sendValue = this.sendValue.bind(this);
        this.changeModelValues = this.changeModelValues.bind(this);
    }

    componentDidMount() {
        //  new window.p5(window.sketch, 'sketch');
    }

    keypress(e) {
        if (!utility.isNumberKey(e)) {
            e.preventDefault();
        }
    }

    selectEquipment(e) {
        let element = e.target;
        if (element.nodeName === "IMG") { //check clicked tag
            element = element.closest('div');
        }
        let name = element.getAttribute('data-name');

        if (name) {
            this.renderModel(name);
            this.setState({selectedEq: name, url: element.getAttribute('data-url')}, () => {
                this.props.select(e)
            });
        }
    }

    renderEquipments() {
        return this.props.equipments.map((ele, i) => {
            let cls = "equipment-profile";
            if (i === this.props.active) {
                cls += " active";
            }
            return (
                <div className={cls} key={"pro_" + i} data-name={ele.name} data-url={ele.url}
                     onClick={e => this.selectEquipment(e)}
                     data-key={i}>
                    <img src={ele.url} alt={ele.name}/>
                    <h3 className="h5 text-center">{ele.name}</h3>
                </div>
            )
        });
    }

    change(e, type = "", val = "") {
        let element = e.target,
            newObject = {},
            suffix = "";
        suffix = element ? element.getAttribute('data-suffix') : ""
        val = val ? val : element.value;

        type = type ? type : element.getAttribute('data-type');

        /*if(this.state.selectedEq==='Aufkantung'){
            if(type === 'height' || type === 'panelSize'){
                let l=this.state.height;
                if(type==='height') l =val;
                newObject['length']=parseInt(this.state.panelSize) - parseInt(l);
            }
        }else if( this.state.selectedEq==='Endkappe'){
            if(type === 'diemension' || type === 'panelSize'){
                let l=this.state.diemension;
                if(type==='diemension') l =val;
                newObject['endcap']=parseInt(this.state.panelSize) - parseInt(l);
            }
        }
*/
        if (suffix) {
            val += suffix;
        }
        newObject[type] = val;
        if (type) {
            this.setState(newObject);
        }
    }

    submitProxy(id) {
        document.getElementById("eq-submit-btn" + id).click();
    }

    sendValue(e) {
        e.preventDefault();
        let d = Utility.objectCopy(this.state);
        this.props.save(d, "equipments");
        //reset state
        this.setState(initialState);
        e.target.reset();
        return this.props.history.push('/');
    }

    changeModelValues(e) {
        let target = e.target,
            type = target.getAttribute('data-type'),
            equipment = utility.getModel(this.state.selectedEq);
        window.drawValues[equipment][type] = parseInt(target.value);
    }

    renderModel(name) {
        window.currentEquipment = utility.getModel(name);
    }

    render() {
        let id = this.props.prefix + this.props.id,
            blendeName1 = "Blende",
            blendeName2 = "Senkrechte Blende";
        let profiles = this.props.standard.map((s, i) => {
            let l = 'Standard Nr.' + (i + 1);
            return {value: i, label: l}
        });

        if (this.state.selectedEq === "T-Formteil") {
            blendeName1 = "Waagrechte Blende";
            blendeName2 = "Senkrechte Blende";
        } else if (this.state.selectedEq === "Wechselecke") {
            blendeName1 = "Linke Blende";
            blendeName2 = "Rechte Blende";
        }

        let drawValue = this.state.drawValues[utility.getModel(this.state.selectedEq)];
        if (!drawValue) {
            drawValue = {}
        }
        return (
            <React.Fragment>
                <div className="content-side col-lg-8 col-md-12 col-sm-12">
                    <div className="equipments">
                        <div className="canvas-controls">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>A-Maß</label>
                                            <input className="form-control" type="number" defaultValue={drawValue.a}
                                                   onKeyUp={this.changeModelValues} data-type="a"/>
                                        </div>
                                    </div>

                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>B-Maß</label>
                                            <input type="number" className="form-control" defaultValue={drawValue.b}
                                                   onKeyUp={e => this.changeModelValues(e)} data-type="b"/>
                                        </div>
                                    </div>

                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>C-Maß</label>
                                            <input type="number" className="form-control" defaultValue={drawValue.c}
                                                   onKeyUp={e => this.changeModelValues(e)} data-type="c"/>
                                        </div>
                                    </div>

                                    <div className="col-3">
                                        <div className="form-group">
                                            <label>Angle</label>
                                            <input type="number" className="form-control" defaultValue={drawValue.c}
                                                   data-type="angle"/>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="card equipment-card border-0 mb-4">
                            <form onSubmit={e => this.sendValue(e)}>
                                <h5 className="card-header border-0" data-target={"#" + id}
                                    onClick={e => this.props.showCard(e)}>Formteile Nr. {this.props.id} <span
                                    className="float-right icon icon-arrow-up mt-1 arw"></span></h5>
                                <div className={"card-body collapse show"} id={id}>
                                    <div className="col-12 mb-4">
                                        <p>Wählen Sie das von Ihnen gewünschte Formteil aus. Definieren Sie es nach
                                            Ihren
                                            Ansprüchen</p>
                                        {this.renderEquipments()}
                                    </div>

                                    {/*<div className="col-12 mb-4">
                                        <div className="row">
                                <div className="col-5">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" onChange={e=>this.props.change(e)} defaultChecked={true} data-type="type" id={"check-a"+id} value="Aussenecke" />
                                        <label className="form-check-label" htmlFor={"check-a"+id}>Aussenecke</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" onChange={e=>this.props.change(e)} data-type="type" id={"check-b"+id} value="Innenecke" />
                                        <label className="form-check-label" htmlFor={"check-b"+id}>Innenecke</label>
                                    </div>
                                </div>
                            </div>
                                    </div>*/}
                                    <div className="col-12 mb-4">
                                        <div className="row">

                                            <div className="col-6">
                                                <h5 className="card-title">{blendeName1}</h5>
                                                <div className="form-group">
                                                    <Select options={profiles}
                                                            onChange={(e, a) => this.change({}, blendeName1, e)}/>
                                                </div>
                                            </div>

                                            {(this.state.selectedEq === "T-Formteil" || this.state.selectedEq === "Wechselecke") && (
                                                <div className="col-6">
                                                    <h5 className="card-title">{blendeName2} <i data-tip={true}
                                                                                                className="icon icon-info"
                                                                                                data-for='waagrecht-info'></i>
                                                    </h5>
                                                    <ReactTooltip type="dark" id='waagrecht-info'>
                                                        <span>Wir empfehlen mindestens die Breite Ihrer waagrechten Blende + 500mm</span>
                                                    </ReactTooltip>
                                                    <div className="form-group">
                                                        <Select options={profiles}
                                                                onChange={(e, a) => this.change({}, blendeName2, e)}/>
                                                    </div>
                                                </div>
                                            )}

                                            {this.state.selectedEq === "Aufkantung" && (
                                                <Fragment>

                                                    <div className="col-6 col-xs-12">
                                                        <h5 className="card-title">Höhe der Aufkantung</h5>
                                                        <div className="form-group">
                                                            <input className="form-control"
                                                                   onChange={e => this.change(e)}
                                                                   data-type="height"
                                                                   id={"height" + id} type="number"
                                                                   spellCheck="false"/>
                                                        </div>
                                                    </div>

                                                    <div className="col-4 col-lg-6">
                                                        <h5 className="card-title">Länge der Aufkantung: <i
                                                            data-tip={true}
                                                            className="icon icon-info"
                                                            data-for='Lange-info'></i>
                                                            <ReactTooltip type="dark" id='Lange-info'>
                                                                <span>Die Breite Ihrer Blende</span>
                                                            </ReactTooltip>
                                                        </h5>
                                                        <div className="form-group">
                                                            <input className="form-control length"
                                                                   onChange={e => this.change(e)} data-type="length"
                                                                   id={"length" + id} type="number" data-suffix="mm"
                                                                   spellCheck="false"/>
                                                        </div>
                                                    </div>

                                                </Fragment>
                                            )}

                                            {(this.state.selectedEq === "Aufkantung" || this.state.selectedEq === "Endkappe") && (
                                                <Fragment>

                                                    {/*<div className="col-6 col-xs-12">
                                                        <h5 className="card-title">Tafelmaß</h5>
                                                        <div className="form-group">
                                                            <select className="form-control" onChange={e => this.change(e)} data-type="panelSize" data-suffix="mm">
                                                                <option value="3000">3000mm</option>
                                                                <option value="4000">4000mm</option>
                                                                <option value="5000">5000mm</option>
                                                            </select>
                                                        </div>
                                                    </div>*/}

                                                </Fragment>
                                            )}

                                            {(this.state.selectedEq !== "Aufkantung" && this.state.selectedEq !== "Endkappe") && (
                                                <div className="col-6 col-xs-12">
                                                    <h5 className="card-title">Winkel</h5>
                                                    <div className="form-group">
                                                        <input className="form-control winkel"
                                                               onChange={e => this.change(e)}
                                                               data-type="winkel"
                                                               id={"winkel" + id} type="number" data-suffix="∠"
                                                               spellCheck="false"/>
                                                    </div>
                                                </div>
                                            )}

                                            {(this.state.selectedEq === "Außenecke" || this.state.selectedEq === "Innenecke") && (
                                                <React.Fragment>
                                                    <div className="col-12 col-lg-6">
                                                        <h5 className="card-title">Schenkellänge <i data-tip={true}
                                                                                                    className="icon icon-info"
                                                                                                    data-for='Schenkellange-info'></i>
                                                        </h5>
                                                        <ReactTooltip type="dark" id='Schenkellange-info'>
                                                            <span>Wir empfehlen die Breite Ihrer ausgewählten Blende + 250mm</span>
                                                        </ReactTooltip>

                                                        <div className="form-group">
                                                            <input className="form-control Schenkellange"
                                                                   onChange={e => this.change(e)}
                                                                   data-type="length"
                                                                   type="number" data-suffix="mm" spellCheck="false"/>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}


                                            {(this.state.selectedEq === "Endkappe") && (
                                                <React.Fragment>
                                                    <div className="col-6 col-xs-12">
                                                        <h5 className="card-title">Maß der Sichtblende:</h5>
                                                        <div className="form-group">
                                                            <input className="form-control diemension"
                                                                   onChange={e => this.change(e)}
                                                                   data-type="diemension"
                                                                   type="number" data-suffix="" spellCheck="false"/>
                                                        </div>
                                                    </div>

                                                    <div className="col-6 col-xs-12">
                                                        <h5 className="card-title">Länge Endkappe:</h5>
                                                        <div className="form-group">
                                                            <input className="form-control endcap"
                                                                   value={this.state.endcap}
                                                                   onChange={e => this.change(e)}
                                                                   data-type="endcap" type="text"
                                                                   data-suffix="" spellCheck="false"/>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            {(this.state.selectedEq === "Wechselecke" || this.state.selectedEq === "T-Formteil") && (
                                                <React.Fragment>
                                                    <div className="col-12 col-lg-6">
                                                        <h5 className="card-title">Schenkellänge Links <i
                                                            data-tip={true}
                                                            className="icon icon-info"
                                                            data-for='Links-info'></i>
                                                        </h5>
                                                        <ReactTooltip type="dark" id='Links-info'>
                                                            <span>Wir empfehlen mindestens die Breite Ihrer linken Blende + 250mm</span>
                                                        </ReactTooltip>
                                                        <div className="form-group">
                                                            <input className="form-control eq-links"
                                                                   onChange={e => this.change(e)} data-type="links"
                                                                   type="number" data-suffix=""/>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-lg-6">
                                                        <h5 className="card-title">Schenkellänge Rechts <i
                                                            data-tip={true}
                                                            className="icon icon-info"
                                                            data-for='Rechts-info'></i>
                                                            <ReactTooltip type="dark" id='Rechts-info'>
                                                                <span>Wir empfehlen die Breite Ihrer rechten Blende + 250mm</span>
                                                            </ReactTooltip>
                                                        </h5>
                                                        <div className="form-group">
                                                            <input className="form-control eq-rechts "
                                                                   onChange={e => this.change(e)} data-type="rechts"
                                                                   type="number" data-suffix=""
                                                                   spellCheck="false"/>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )}


                                            <div className="col-6 col-xs-12">
                                                <h5 className="card-title">Menge der Formteile</h5>
                                                <div className="form-group">
                                                    <input className="form-control" type="number" required
                                                           onChange={e => this.change(e)}
                                                           data-type="pieces"
                                                           id={"pieces" + id}
                                                           spellCheck="false"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="d-none" type="submit" id={"eq-submit-btn" + this.props.id}>Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                <Sidebar proxyClick={this.submitProxy} resetEdit={this.props.resetEdit} id={this.props.id}
                         save={this.sendValue} type="equipment" data={this.state}
                         name={"Equipment Nr." + this.props.id}/>
            </React.Fragment>
        )
    }
}

export default Equipments;
